module.exports = __webpack_public_path__ + "img/Stab_AB.82f2b05d.svg";